module.exports = "<div class=\"widget-aside v15\">\r\n  <h6 class=\"widget-aside__title\">Nuestros Productos</h6>\r\n  <div class=\"widget-aside__wrapper\">\r\n    <categories-accordion items=\"$ctrl.shCtrl.globalCategoriesMenu[0].hijas\"></categories-accordion>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./www/components/catalog/categories-filter/categories-slider-filter/templates/categories-slider-filter-t15.view.html
// module id = 450
// module chunks = 0